import React, { useState } from "react";
import { db } from "../../../../assets/firebase/firebaseconfig";
import {
  ref,
  query,
  orderByChild,
  equalTo,
  get,
  update,
} from "firebase/database";
import { useNavigate } from "react-router-dom";
import "./styles.css";
import "../../styles.css";

const ForgotPasswordHome = () => {
  const [step, setStep] = useState(1); // Bước 1: Xác thực, Bước 2: Đổi pass
  const [formData, setFormData] = useState({
    username: "",
    phone: "",
    newPassword: "",
  });
  const [userId, setUserId] = useState(null);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  // Bước 1: Kiểm tra thông tin
  const handleVerify = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const userRef = ref(db, "users");
      const userQuery = query(
        userRef,
        orderByChild("username"),
        equalTo(formData.username)
      );
      const snapshot = await get(userQuery);

      if (snapshot.exists()) {
        const data = snapshot.val();
        const id = Object.keys(data)[0];
        const user = data[id];

        if (user.phone === formData.phone) {
          setUserId(id);
          setStep(2); // Thông tin đúng, chuyển sang bước đổi mật khẩu
        } else {
          const msg = "Số điện thoại không khớp với tài khoản này!";
          setError(msg);
          alert(msg);
        }
      } else {
        const msg = "Tên đăng nhập không tồn tại!";
        setError(msg);
        alert(msg);
      }
    } catch (err) {
      setError("Lỗi kết nối!");
    }
  };

  // Bước 2: Cập nhật mật khẩu mới
  const handleReset = async (e) => {
    e.preventDefault();
    try {
      await update(ref(db, `users/${userId}`), {
        password: formData.newPassword,
      });
      alert("Mật khẩu đã được thay đổi thành công!");
      setError("");
      navigate("/dang-nhap");
    } catch (err) {
      const msg = "Không thể cập nhật mật khẩu!";
      setError(msg);
      alert(msg);
    }
  };

  return (
    <div className="login-container card">
      <h2>{step === 1 ? "KHÔI PHỤC MẬT KHẨU" : "ĐẶT MẬT KHẨU MỚI"}</h2>

      {step === 1 ? (
        <form onSubmit={handleVerify}>
          <p style={{ fontSize: "13px", color: "#666", marginBottom: "15px" }}>
            Nhập tên đăng nhập và số điện thoại đã đăng ký để xác minh.
          </p>
          <input
            type="text"
            placeholder="Tên đăng nhập"
            required
            onChange={(e) =>
              setFormData({ ...formData, username: e.target.value })
            }
          />

          <input
            type="text"
            placeholder="Số điện thoại đăng ký"
            required
            onChange={(e) =>
              setFormData({ ...formData, phone: e.target.value })
            }
          />

          <button type="submit" className="btn-submit-contact">
            TIẾP TỤC
          </button>
        </form>
      ) : (
        <form onSubmit={handleReset}>
          <input
            type="password"
            placeholder="Mật khẩu mới"
            required
            onChange={(e) =>
              setFormData({ ...formData, newPassword: e.target.value })
            }
          />
          {error && <p className="error-text">{error}</p>}
          <button type="submit" className="btn-submit-contact">
            XÁC NHẬN ĐỔI MẬT KHẨU
          </button>
        </form>
      )}
    </div>
  );
};

export default ForgotPasswordHome;
